import React from 'react';

import styles from './FormattedOrganizationMembershipCode.module.scss';
import {
  ORGANIZATION_MEMBERSHIP_CODE_TOTAL_DIGITS,
  splitOrganizationMembershipCode,
} from './organizationMembershipCode';
import OrganizationMembershipCodeGroups from './OrganizationMembershipCodeGroups';

interface Props {
  code: string;
}

const FormattedOrganizationMembershipCode: React.FC<Props> = ({ code }) => {
  const digits = code.replace(/\D/g, '');
  if (digits.length !== ORGANIZATION_MEMBERSHIP_CODE_TOTAL_DIGITS) {
    return <span>{code}</span>;
  }

  const groups = splitOrganizationMembershipCode(digits);

  return (
    <OrganizationMembershipCodeGroups
      groups={groups}
      separatorClassName={styles.separator}
    />
  );
};

export default FormattedOrganizationMembershipCode;
